import TemplateContainer from './TemplateContainer'

export default TemplateContainer
